import React from 'react';
import createReactClass from 'create-react-class';

import { getMenuItems } from '@/exceed';
import { registerField } from 'core/forms';

import addAudienceSelectionModal from '../helpers/addAudienceSelectionModal';

import FormFieldAudienceChips from '../components/formFieldAudienceChips';

const FormFieldAudienceChipsContainer = createReactClass({
  getInitialState() {
    return { audiences: this.props.value || [] };
  },

  handleChipClick(audience) {
    this.setState(({ audiences }) => ({
      audiences: audiences.filter(({ id }) => id !== audience.id),
    }), this.updateField);
  },

  async handleExistingAudienceClick() {
    const { payload, type } = await addAudienceSelectionModal(this.state.audiences);

    if (type !== 'save') return;

    this.setState(({ audiences }) => ({ audiences: [...audiences, payload.audience] }));
    this.updateField();
  },

  async handleNewAudienceClick() {
    const { payload, type } = await addAudienceSelectionModal();

    if (type !== 'save') return;

    this.setState(({ audiences }) => ({ audiences: [...audiences, payload] }));
    this.updateField();
  },

  getMenuItems() {
    return getMenuItems([
      {
        icon: 'audienceAdd',
        key: 'new-audience',
        onClick: this.handleNewAudienceClick,
      },
      {
        icon: 'audience',
        key: 'existing-audience',
        onClick: this.handleExistingAudienceClick,
      },
    ]);
  },

  updateField() {
    this.props.updateField(this.state.audiences);
  },

  render() {
    const { model, schema } = this.props;
    const isDisabled = Boolean(schema.isDisabled);

    return (
      <FormFieldAudienceChips
        audiences={isDisabled ? [model.audience].filter(Boolean) : this.state.audiences}
        isDisabled={isDisabled}
        menuItems={this.getMenuItems()}
        onChipClick={this.handleChipClick}
      />
    );
  },
});

registerField('AudienceChips', React.memo(FormFieldAudienceChipsContainer));

export default FormFieldAudienceChipsContainer;
